import React, {
  useState,
  useEffect,
  useContext,
  createContext,
  useCallback,
} from "react";
import { ProjectData } from "./Components/Projects/ProjectData.js/ProjectData";

const MyAppContext = createContext();

export const MyAppProvider = ({ children }) => {
  const [allProjects, setAllProjects] = useState(ProjectData);
  const [inputs, setMyInputs] = useState({ type: "All" });

  const HandleInputs = (e) => {
    const target = e.target;
    const name = target.name;
    const value = target.value;
    setMyInputs((previous) => {
      return { ...previous, [name]: value };
    });
  };
  const FiltersProjectType = useCallback(() => {
    let { type } = inputs;
    let tempProject = [...ProjectData];
    if (type !== "All") {
      tempProject = tempProject.filter((project) => project.category === type);
    }
    setAllProjects(tempProject);
  }, [inputs]);
  useEffect(() => {
    FiltersProjectType();
  }, [inputs, FiltersProjectType]);
  return (
    <MyAppContext.Provider value={{ allProjects, HandleInputs, ...inputs }}>
      {children}
    </MyAppContext.Provider>
  );
};

export const MyAppGlobalProbider = () => {
  return useContext(MyAppContext);
};
